import { usePathname, useSearchParams } from 'next/navigation'

import { useAppDispatch } from 'store/hooks'
import { sendOptInPromoRequest } from 'store/modules/user/actions'

/**
 * Custom hook that provides opt-in promotional functionality
 * Can be used by any component to add opt-in capabilities
 */
export const useOptInPromo = () => {
  const dispatch = useAppDispatch()
  const pathname = usePathname()
  const query = useSearchParams()

  return (utmCode: string) => {
    const queryString = query.toString()
    const fullPath = encodeURI(`${pathname}${queryString ? '?' + queryString : ''}`)
    dispatch(sendOptInPromoRequest(utmCode, fullPath))
  }
}
